import { InjectionToken } from '@angular/core';

export interface IRoblexInputConfig {
    api: string;
}

export const INPUT_FILE_VALUE_CONFIG: IRoblexInputConfig = {
    api: '',
};

export const INPUT_FILE_CONFIG = new InjectionToken<IRoblexInputConfig>(
    'input-file.config',
    {
        providedIn: 'root',
        factory: () => {
            return INPUT_FILE_VALUE_CONFIG;
        },
    }
);
